import { render } from "./floating.html?vue&type=template&id=6669fb7a&external"
import script from "./floating.js?vue&type=script&lang=js&external"
export * from "./floating.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__